<cmps-dialog>
    <cmps-dialog-header class="header">
        <div class="text size">
            {{ _i18n._10018_SELECT_ADDITIONAL_BEHAVIOURS | translate }}
        </div>
    </cmps-dialog-header>
    <cmps-dialog-body>
        <cmps-wait-status *ngIf="state?.hasPendingData"></cmps-wait-status>
        <div
            class="body"
            *ngIf="!state?.hasPendingData"
        >
            <table>
                <tr
                    *ngFor="let behaviourTag of state.behaviourTagSelection"
                    (click)="_onBehaviourCheckboxChange(behaviourTag)"
                >
                    <td>
                        <cmps-checkbox [ngModel]="behaviourTag.isChecked">
                        </cmps-checkbox>
                    </td>
                    <td>
                        <div>
                            {{ behaviourTag.behaviour.name }}
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div
            class="modal-footer"
            *ngIf="!state?.hasPendingData"
        >
            <button
                cmpsButton
                (click)="_onAddBehavioursClick()"
            >
                <cmps-icon svgIcon="plus"></cmps-icon>
                <span cmpsButtonLabel>{{
                    _i18n._10016_ADD_BEHAVIOUR | translate
                }}</span>
            </button>
        </div>
    </cmps-dialog-body>
</cmps-dialog>
